import { planFeatureID } from "./enums"

export const BLOG_LIST_LIMIT = 5
export const IDEA_MAX_LENGTH = 140
export const SESSION_COOKIE_NAME = "ideate-live-session-id"

export const MAX_PASSWORD_STRENGTH = 136
export const MIN_PASSWORD_STRENGTH = 40.8 // 30%
export const MIN_PASSWORD_STRENGTH_PERCENT = 30

export const EST_IDEA_COUNT_PER_PERSON = 3

export const TRIAL_DAYS = 30

export const REG_ERRORS = {
    address1_required: "address1_required",
    billingName_required: "billingName_required",
    billingCompany_required: "billingCompany_required",
    city_required: "city_required",
    countryCode_invalid: "countryCode_invalid",
    countryCode_required: "countryCode_required",
    email_exists: "email_exists",
    email_required: "email_required",
    email_invalid: "email_invalid",
    lookupKey_invalid: "lookupKey_invalid",
    lookupKey_required: "lookupKey_required",
    password_required: "password_required",
    password_weak: "password_weak",
    postalCode_required: "postalCode_required",
    regType_invalid: "regType_invalid",
    regType_required: "regType_required",
    termsAndPrivacyPolicy: "termsAndPrivacyPolicy",
    vat_invalid: "vat_invalid",
    vat_or_company_number_required: "vat_or_company_number_required",
}

export const FEATURES: Record<string, {
    id: planFeatureID,
    label: string,
    description: string
}> = {
    sessions_per_month: {
        id: planFeatureID.sessions_per_month,
        label: "Sessions per month",
        description: "How many sessions you can start each month"
    },
    max_participants_per_session: {
        id: planFeatureID.max_participants_per_session,
        label: "Participants per session",
        description: "Maximum number of participants who can be part of a session at any given time"
    },
    export_basic: {
        id: planFeatureID.export_basic,
        label: "Export: Basic (csv)",
        description: "Ability to export session results and data in a csv format"
    },
    export_apps: {
        id: planFeatureID.export_apps,
        label: "Export: App (Figma Jam, Miro, Mural, Office)",
        description: "Ability to export session results and data in a format of your choosing to be consumed by other apps such as Figma Jam, Miro, Mural, Office"
    },
    reporting_html: {
        id: planFeatureID.reporting_html,
        label: "Reporting: Web",
        description: "Detailed report of your session and the outcome is available in the web"
    },
    reporting_powerpoint: {
        id: planFeatureID.reporting_powerpoint,
        label: "Reporting: PowerPoint",
        description: "Detailed report of your session and the outcome can be downloaded in PowerPoint format"
    },
    ai_ideas_grouping: {
        id: planFeatureID.ai_ideas_grouping,
        label: "AI: ideas grouping",
        description: "AI can be leveraged to automatically group similar ideas together"
    },
    ai_custom_participants: {
        id: planFeatureID.ai_custom_participants,
        label: "AI: company role participants",
        description: "AI can aid in enhancing the session by providing company role-based ideas. AI participants are not counted towards the max participants limit."
    },
}